import styled from 'styled-components';
import Input from 'styles/elements/input';

export const DateInputShort = styled(Input)`
  width: auto;
`;

export const YearInput = styled(DateInputShort)``;
